import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

import camelToSnake from '../../utils/camelToSnake'
import CustomPrimeTable, { DEFAULT_PAGE_SAZE } from '../../common/PrimeTable/CustomPrimeTable'
import { clearSalesMetricActivities, getActivitiesForSalesMetric } from './Redux/salesMetricReportActions'
import { useDispatch, useSelector } from 'react-redux'
import useContactUrl from '../../hooks/useContactUrl'

const ActivitiesTable = ({ creationDate, userId, isVisits, isDemos, divisionId, activityType }) => {
  const DEFAULT_PAGINATION = { limit: DEFAULT_PAGE_SAZE, first: 0 }
  const [options, setOptions] = useState({
    pagination: DEFAULT_PAGINATION,
    sort: {},
    filter: { dateRange: creationDate, assigned: userId, isVisits, isDemos, divisionId, activityType },
    tableFilter: {},
  })

  const { activities } = useSelector((state) => ({
    activities: state.SalesMetricReport.activities,
  }))

  const dispatch = useDispatch()

  const { getUrl } = useContactUrl()

  useEffect(() => {
    dispatch(getActivitiesForSalesMetric(options))

    return () => dispatch(clearSalesMetricActivities())
  }, [options])

  const onFilterChange = async (event) => {
    let tableFilter = {}
    Object.keys(event.filters).forEach(function (key) {
      tableFilter[camelToSnake(key)] = event.filters[key].value
    })
    setOptions({
      ...options,
      tableFilter,
      pagination: DEFAULT_PAGINATION,
    })
  }

  const onSortChange = async (event) => {
    let sort = {}

    if (event.multiSortMeta) {
      event.multiSortMeta.map((row) => {
        sort[row.field] = row.order
      })
    }

    setOptions({
      ...options,
      sort,
      pagination: DEFAULT_PAGINATION,
    })
  }

  const onPageChange = async (event) => {
    const pagination = { limit: event.rows, first: event.first }
    setOptions((p) => ({
      ...p,
      pagination,
    }))
  }

  const userBody = (rowData) => {
    return <div>{rowData.userData.name}</div>
  }

  const contactLink = (rowData) => {
    return <Link onClick={() => window.open(getUrl(rowData.contactData), '_blank')}>{rowData.contactData.name}</Link>
  }

  const activityBody = (rowData) => {
    return <div style={{ textAlign: 'center' }}>{rowData.activityData.name}</div>
  }

  const notesBody = (rowData) => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: rowData.notes,
        }}
      />
    )
  }

  const columns = [
    {
      field: 'creationDate',
      style: { textAlign: 'center' },
      header: 'Date',
      format: 'MM-DD-YYYY',
    },
    { field: 'u.name', header: 'User', body: userBody, style: { textAlign: 'center' } },
    { field: 'c.name', header: 'Contact', body: contactLink, style: { textAlign: 'center' } },
    { field: 'numberOfTrucks', header: 'Trucks', style: { textAlign: 'center' } },
    { field: 'a.activity_type', header: 'Activity', body: activityBody, style: { textAlign: 'center' } },
    {
      field: 'a.notes',
      header: 'Notes',
      body: notesBody,
      style: { textAlign: 'center', width: '33%' },
    },
  ]
  // todo

  return (
    <>
      <CustomPrimeTable
        data={activities.data}
        columns={columns}
        addHidden={true}
        onFilter={onFilterChange}
        onSort={onSortChange}
        onPage={onPageChange}
        query={activities.query}
        showActions={false}
      />
    </>
  )
}

export default ActivitiesTable
